export const formatDms = (dms) => {
  return `${dms.modifier === '1' ? '+' : '-'}${dms.degrees}\xB0 ${dms.minutes}' ${dms.seconds}"`
}
